import React from 'react'
import {useIntl} from 'react-intl'
import {Button, InputSearch} from '../../../../_gori/partials/widgets'
import {KTSVG, toAbsoluteUrl} from '../../../../_gori/helpers'
import FileSaver from 'file-saver'
const BatchesFilter: React.FC = () => {
  const intl = useIntl()

  return (
    <div className='d-flex flex-column flex-fill'>
      <div className='d-flex flex-wrap justify-content-between align-items-start gap-3'>
        <div className='d-flex align-items-start position-relative filter-toolbar-44 filter-full-tablet'>
          <InputSearch placeholder={intl.formatMessage({id: 'SEARCH_BATCH'})} />
        </div>
        <div className='d-flex flex-row flex-wrap gap-3 align-items-start filter-toolbar-44 filter-full-tablet filter-stack-small'>
          <Button
            event={() =>
              FileSaver.saveAs(
                toAbsoluteUrl('/media/gori/batches/ShipBae_Batch_Template_Domestic.csv'),
                'ShipBae_Batch_Template_Domestic.csv'
              )
            }
            classNameDiv='filter-five-tenths'
            className='btn btn-advanced-secondary btn-sm fw-bolder rounded-2 w-100 align-items-center justify-content-center'
            label={intl.formatMessage({id: 'BATCH_TEMPLATE'})}
            children={<KTSVG path='/media/gori/batches/file_download.svg' />}
          />
          <Button
            event={() =>
              FileSaver.saveAs(
                toAbsoluteUrl('/media/gori/batches/ShipBae_Batch_Template_International.csv'),
                'ShipBae_Batch_Template_International.csv'
              )
            }
            classNameDiv='filter-grow-tablet filter-full-small'
            className='btn btn-advanced-secondary btn-sm fw-bolder rounded-2 w-100 align-items-center justify-content-center'
            label={intl.formatMessage({id: 'BATCH_TEMPLATE_INTL'})}
            children={<KTSVG path='/media/gori/batches/file_download.svg' />}
          />
        </div>
      </div>
    </div>
  )
}

export {BatchesFilter}
